import script from "./AnimalResultCard.vue?vue&type=script&setup=true&lang=js"
export * from "./AnimalResultCard.vue?vue&type=script&setup=true&lang=js"

import "./AnimalResultCard.vue?vue&type=style&index=0&id=a782f634&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a782f634"]])

export default __exports__